<template functional>
    <div class="v2_info-popup__body px-2">
      <ul class="list-style-disc pl-3">
        <li>
            Monitor and manage your job opportunities.
            <ul>
                <li>Monitor the status of matched candidates</li>
                <li>Manage communications with candidates </li>
                <li>Edit the details of an active job opportunity, as needed</li>
            </ul>
        </li>
        <!-- <li>
            Active job opportunities = opportunities you have paid for and posted.
        </li>
        <li>Pending job opportunities = opportunities you have paid for but have not posted (while you review market data or weigh other considerations).</li>
        <li>
            Planned job opportunities = opportunities you have defined and named but not yet paid for or posted (waiting to see when matching candidates appear)
        </li>
        <li>
            Closed or Filled job opportunities = opportunities you have successfully placed or no longer intend to pursue
        </li> -->
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DashboardInfoPopupContent',
  };
  </script>
  
  <style scoped lang="scss">
  .v2_info-popup__body {
    ul {
      list-style-type: none;
      padding: 0;
    }
  }
  ul {
    margin: 0;
    padding: 0;
  }

  ul ul {
    margin-left: 20px;
  }
  ul ul li{
    list-style-type: circle;
  }
  ul li{
    margin-bottom: 5px;
  }
  ul li ul{
    margin-top:15px;
    margin-bottom: 20px;
  }
  </style>
  